/**
 * Phase 4 Task 10 — callback scheduling event contracts.
 *
 * Three lifecycle events emitted around scheduled callback originations:
 *
 *  - `callback.scheduled` — published by the API when a new row is
 *    inserted into `tenant_<slug>.callback_attempts` via `POST /callbacks`.
 *  - `callback.originated` — published by the worker scheduler tick after
 *    the AriPool returns a channel id for a due callback.
 *  - `callback.failed` — published when the originate raises (status flips
 *    to FAILED) or attempt_count >= max_attempts.
 *
 * `agentId` on `callback.scheduled` is nullable for cold/next-available
 * callbacks where no specific agent owns the request.
 */
import { z, uuidSchema, phoneE164Schema } from '@kc3/validation';
import { baseEventFields, isoDatetimeSchema } from './_base.js';
export const CallbackScheduledEventSchema = z.object({
    type: z.literal('callback.scheduled'),
    ...baseEventFields,
    callbackId: uuidSchema,
    phoneE164: phoneE164Schema,
    scheduledAt: isoDatetimeSchema,
    agentId: uuidSchema.nullable(),
});
export const CallbackOriginatedEventSchema = z.object({
    type: z.literal('callback.originated'),
    ...baseEventFields,
    callbackId: uuidSchema,
    channelId: z.string().min(1),
});
export const CallbackFailedEventSchema = z.object({
    type: z.literal('callback.failed'),
    ...baseEventFields,
    callbackId: uuidSchema,
    reason: z.string().min(1),
});
//# sourceMappingURL=callback.js.map